const Constants = {
  EMO_SAVING_METHODS: {
    "Site": {
      1: "saving_pcn"
    },
    "Location": {
      1: "saving_pcn"
    },
    "Asset": {
      1: "saving_pcn", 
      2: "energy_change"
    }
  },
  EMO_CATEGORIES: {
    10: "replacement",
    20: "operational",
    30: "administrative",
    40: "maintenance",
    50: "modification"
  },
  // copy straight from models/issue.rb
  ISSUE_SEVERITY: {
    critical: 90,
    major: 80,
    minor: 70,
    observation: 60    
  },
  ISSUE_PRIORITIES: {
    high: 30,
    medium: 20,
    low: 10
  },
  STATUS: {
    open: 10,
    in_progress: 20,
    pending: 30,
    closed: 90,
    cancelled: 99
  }
}

export default Constants;